import * as React from 'react';
import { appContext } from '../../../AppContext';
import defaultCustomerLogo from './CustomerLogo.png';
import { DateTime } from 'luxon';
import { JSX } from 'react';
import GlobeIcon from '../../Icons/GlobeIcon';
import "./Styles.scss";
import { IconButton } from '@serendie/ui';
import { GridContainer, GridItem, LanguageDialog, ScreenSize, Typography } from '@iconics/components';

class IbssFooter extends React.Component<IProps, IState> {
    private labels = appContext().labels;

    constructor(props: IProps)
    {
        super(props);
        this.state = {
            showLanguageDialog: false,
            languageIcon: <GlobeIcon />,
        };
    }

    public componentDidMount(): void
    {
        const isDevMode = appContext().settings.devMode;
        const currentLanguageCode = appContext().language.current;

        const currentLang = appContext()
            .language
            .languages
            .filter(i => (isDevMode ? true : i.code != appContext().localisation.terms))
            .find(i => i.code === currentLanguageCode);

        if (currentLang) 
        {
            this.setState({ languageIcon: currentLang.icon });
        }
    }

    public render(): JSX.Element
    {
        const isExpanded = (this.props.screenSize == 'expanded');
        const languageWidth = (isExpanded ? 1 : 2);
        const customerLogoWidth = (isExpanded ? 1 : undefined);
        const copyrightWidth = (isExpanded ? 8 : 10);
        const iconicsLogoWidth = (isExpanded ? 2 : undefined);

        return (
            <>
                <GridContainer
                    className='footer'
                >
                    <GridItem
                        compact={languageWidth}
                        className='footer__language'
                    >
                        {
                            this.props.showLanguageButton &&
                            <IconButton
                                size='medium'
                                shape='circle'
                                styleType='ghost'
                                icon={<span className={'footer__language-option-label' + (this.state.languageIcon ? ' footer__language-option-label--border' : '')}>{this.state.languageIcon ?? <GlobeIcon />}</span>}
                                onClick={() => this.setState({ showLanguageDialog: true })}
                            />
                        }
                    </GridItem>
                    {
                        isExpanded &&
                        <GridItem
                            compact={customerLogoWidth}
                            className='footer__customer-logo'
                        >
                            <img
                                src={this.props?.customerLogoSrc ?? defaultCustomerLogo}
                                alt={this.props?.customerLogAltText ?? "partner company logo"}
                            />
                        </GridItem>
                    }
                    <GridItem
                        compact={copyrightWidth}
                        className='footer__copyright'
                    >
                        <Typography role='body'>
                            {`${this.labels.Platform_Copyright} ${DateTime.now().year}`}
                        </Typography>
                    </GridItem>
                    {
                        isExpanded &&
                        <GridItem
                            compact={iconicsLogoWidth}
                            className='footer__iconics-logo'
                        >
                            <img
                                src="/images/Logos/Iconics_logo_light.png"
                                alt="Iconics company logo light version"
                            />
                        </GridItem>
                    }
                </GridContainer>
                <LanguageDialog
                    open={this.state.showLanguageDialog}
                    onClose={() => this.setState({ showLanguageDialog: false })}
                    getCurrentLanguage={() => Promise.resolve(appContext().language.current)}
                    localisation={appContext().localisation}
                />
            </>
        )
    }
}

export default IbssFooter;

export interface IProps
{
    screenSize: ScreenSize;
    showLanguageButton?: boolean;
    customerLogoSrc?: string;
    customerLogAltText?: string;
}

export interface IState
{
    showLanguageDialog: boolean;
    languageIcon: JSX.Element;
}
